import React, { useState, useEffect} from 'react';
import { Tooltip, Image as AntdImage, Spin } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";

import "./index.scss";
import Api from '../../../../../api'
import storage from "../../../../../utils/storage";
import RightArrow from "../../../../../assets/img/V7/rightArrow.png";
import StartBlack from "../../../../../assets/img/V7/startBlack.png";
import RightArrowBlack from "../../../../../assets/img/V7/rightArrowBlack.png";
import { setAIModalState } from "../../../../../features/AIIntelligentV7/AIReducer";
const RecommendList = () => {
    const dispatch = useDispatch();

    const [dataList, setDataList] = useState([]);
    const [spinning, setSpinning] = useState(false); 

    useEffect(()=>{
        getInitDate();
    },[])
    const getInitDate = async() => {
        try{
            setSpinning(true);
            const res = await Api.ChatV7.getRecommendList({data:{num:1}});

            setSpinning(false);
            if(res && res.code === 0 && res.data){
                setDataList([
                    ...res.data
                ]);
            }
        }catch(e){
            setSpinning(false);
            console.log(e);
        }
        
    }

    const goKnowledgeList = (item) => {
        let param = {
            "query": item,
            "saerchParams": {
                "knowledgeType": 'home'
            }
        }
        storage.setItem('aiQAParams', param)
        window.open('/page/knowledgeQA');   
    }

    return (
        <div className="recommendList">
            <div className="recommendListTitle"> 
                <div>你可能感兴趣</div>
                <div className="exchange" onClick={getInitDate}> 
                    <SyncOutlined />换一换
                </div>
            </div>
            <Spin spinning={spinning}>
                <div className="recommendListBox">
                    {dataList.map((item,index)=>{
                        return (
                            <div
                                key={index}
                                className="recommendListItem"
                                onClick={()=>{
                                    goKnowledgeList(item)
                                }}
                            >
                                <div className="recommendListItemImage">
                                    {/* <AntdImage
                                        width={16}
                                        preview={false}
                                        src={StartBlack}
                                    /> */}
                                </div>
                                <div className="recommendListItemTitle">
                                    {item}
                                </div>
                                <div className="rightArrow">
                                    {/* <img className="rightArrow" src={RightArrowBlack} alt=""/>  */}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Spin>
        </div>
    );
}
export default RecommendList;
